import { TextField } from '@material-ui/core'
import { actions, useDispatch, useSelector } from '@/redux'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'

import TableSearchForm from '@/components/Table/TableSearchForm'

const defaultState = {
  page: 1,
  jobId: '',
  admin: '',
  remark: '',
  startedAt: '',
  endedAt: '',
}

/**
 *
 * @param {*} props
 * @returns
 */
export default function ReportJobSearchForm (props) {
  const dispatch = useDispatch()
  const classes = useStyles(props)
  const [inputState, setInputState] = React.useState(defaultState)
  const params = useSelector(state => state.report.job.params)

  React.useEffect(() => {
    if (params) {
      setInputState(params)
    }
  }, [params])

  const handleChange = (event) => {
    const { name, value } = event.currentTarget
    setInputState(prev => { return { ...prev, [name]: value } })
  }

  const handleSearch = (event) => {
    event.preventDefault()
    dispatch(actions.report.updateJobQuery({ ...inputState, page: 1 }))
  }

  const handleClear = (event) => {
    event.preventDefault()
    dispatch(actions.report.updateJobQuery(defaultState))
  }

  return (
    <TableSearchForm
      handleSearch={handleSearch}
      handleClear={handleClear}
    >
      <TextField
        label='Job ID'
        name='jobId'
        type='text'
        variant='outlined'
        size='small'
        fullWidth
        classes={{ root: classes.textField }}
        value={inputState.jobId}
        onChange={handleChange}
        onKeyPress={(e) => {
          if (e.key === 'Enter') {
            handleSearch(e)
          }
        }}
      />
      <TextField
        label='Admin'
        name='admin'
        type='text'
        variant='outlined'
        size='small'
        fullWidth
        classes={{ root: classes.textField }}
        value={inputState.admin}
        onKeyPress={(e) => {
          if (e.key === 'Enter') {
            handleSearch(e)
          }
        }}
        onChange={handleChange}
      />
      <TextField
        label='Remark'
        name='remark'
        type='text'
        variant='outlined'
        size='small'
        fullWidth
        classes={{ root: classes.textField }}
        value={inputState.remark}
        onKeyPress={(e) => {
          if (e.key === 'Enter') {
            handleSearch(e)
          }
        }}
        onChange={handleChange}
      />
      <TextField
        label='Start date'
        name='startedAt'
        type='date'
        variant='outlined'
        size='small'
        fullWidth
        classes={{ root: classes.textField }}
        value={inputState.startedAt}
        onKeyPress={(e) => {
          if (e.key === 'Enter') {
            handleSearch(e)
          }
        }}
        onChange={handleChange}
        InputLabelProps={{
          shrink: true,
        }}
      />
      <TextField
        label='End date'
        name='endedAt'
        type='date'
        variant='outlined'
        size='small'
        fullWidth
        classes={{ root: classes.textField }}
        value={inputState.endedAt}
        onKeyPress={(e) => {
          if (e.key === 'Enter') {
            handleSearch(e)
          }
        }}
        onChange={handleChange}
        InputLabelProps={{
          shrink: true,
        }}
      />
    </TableSearchForm>
  )
}

const useStyles = makeStyles(theme => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '1fr auto',
    gap: theme.spacing(2),
    margin: theme.spacing(1, 0),
  },
  textField: {
    background: theme.palette.common.white,
  },
  actions: {
    display: 'grid',
    gridTemplateColumns: 'auto auto',
    gap: theme.spacing(1),
  },
  fileds: {
    display: 'grid',
    gridTemplateRows: 'auto',
    gap: theme.spacing(1),
  },
}))
